import React from "react";
import "../../App.css";

export default function Awards() {
  return (
    <div className="awards">
      <h1>Awards</h1>
    </div>
  );
}
